/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import contactSideImg from '../../data/images/ysLogo2.png';

import emailjs from 'emailjs-com';
import img_01 from '../../data/icons/contact.png';


type StateType = {
    name: string;
    school: string;
    phoneNum: string;
    message: string;
};

const initialState: StateType = {
    name: '',
    school: '',
    phoneNum: '',
    message: '',
};

const Contact = () => {
    const [ formState, setFormState ] = useState(initialState);

    const handleChange = (event: any) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormState((prevState: any) => ({
            ...prevState,
            [name]: value
        }))
    };
    console.log(formState)
    const theme = useTheme();

    const handleSubmit = (event: any) => {

        if (formState.name && formState.school && formState.phoneNum && formState.message !== '') {
            emailjs.send(`service_rpota0f`, `template_9s766r9`, {
                name: formState.name,
                school: formState.school,
                phoneNum: formState.phoneNum,
                message: formState.message,
                }, 'zL8LyiF-amSDlEiwx')
                .then((result) => {
                    console.log(result.text);
                }, (error) => {
                    console.log(error.text);
                });
                alert("건의 사항이 접수 되었습니다.");
        } else {
            alert("이메일과 내용을 모두 입력하세요.");
        };

    };


    return (
        <Grid 
            container 
            spacing={0}
            sx={{ 
                boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px',
                borderRadius: '15px',
                width: '99%',
                mt: 15,
                mb: 15,
                }}
                >
            <Grid item xs={12} md={6} lg={5} sx={{
                m: 10,
                '@media (max-width: 1300px)': {
                    width: '100%',
                    m: 3,
                    mt: 5,
                }
            }}>
                <Box marginBottom={4}>
                <Typography sx={{ textAlign: 'center', ml: '-10em' }}>
                    <img src={img_01} width={100} />
                </Typography>
                <Typography 
                    sx={{ 
                        fontSize: '3em', 
                        fontWeight: 700,
                        '@media (max-width: 1300px)': {
                            fontSize: '1.5em', 
                        }
                        }} gutterBottom>
                    Contact us
                </Typography>
                <Typography color="text.secondary">
                    건의 사항이나 궁금한 점이 있으신가요?
                </Typography>
                </Box>
                <Box>
                <form noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            sx={{ height: 54 }}
                            label="이름"
                            variant="outlined"
                            color="primary"
                            size="medium"
                            name="name"
                            fullWidth
                            value={formState.name}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                        sx={{ height: 54 }}
                        label="소속"
                        variant="outlined"
                        color="primary"
                        size="medium"
                        name="school"
                        fullWidth
                        value={formState.school}
                        onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        sx={{ height: 54 }}
                        label="연락처"
                        type="phoneNum"
                        variant="outlined"
                        color="primary"
                        size="medium"
                        name="phoneNum"
                        fullWidth
                        value={formState.phoneNum}
                        onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                        label="문의내용을 입력하세요"
                        multiline
                        rows={6}
                        variant="outlined"
                        color="primary"
                        size="medium"
                        name="message"
                        fullWidth
                        value={formState.message}
                        onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            size="medium"
                            type="submit"
                            sx={{
                                backgroundColor: '#308cff',
                                '&: hover': {
                                    backgroundColor: '#439dff',
                                }
                            }}
                        >
                        문의하기
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Box>
                            <Typography color="text.secondary" sx={{ '@media (max-width: 1300px)': { fontSize: '0.7em' } }}>
                                문의내용 확인 후, 빠른 시일내에 답변드리겠습니다.
                            </Typography>
                        </Box>
                    </Grid>
                    </Grid>
                </form>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={5} m={3} 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    padding: 5,
                    ml: 10,
                    '@media (max-width: 1300px)': {
                        display: 'none'
                    }
                    }}>
                <img src={contactSideImg} 
                    style={{ 
                    }} 
                    />
            </Grid>
        </Grid>
    );
};

export default Contact;
